import * as Yup from 'yup';

import i18n from 'i18n';
import { validateHex } from 'services/common/colorsHelper';
import { MAX_LIMIT_DIGITS, MAX_TITLE_LENGTH } from 'services/constants';

import { SectionType } from 'types/enums';
import { SectionCreateKey } from './interfaces';

export const SECTION_DEFAULTS = {
  type: SectionType.simple,
  name: '',
  description: '',
  time: '',
};

export const SECTION_SETTINGS_DEFAULTS = {
  visibleForGuests: false,
  visibleForHosts: true,
  timeEnabled: true,
  songsEnabled: true,
  notesEnabled: true,
  canHostsOrderSongs: true,
  canHostDeleteSection: true,
  notesVisibleForHosts: true,
  canHostChangeSectionName: true,
  canHostChangeSectionTime: true,
};

export const headlineColorValidateField = Yup.string()
  .nullable()
  .trim()
  .test({
    name: 'name',
    message: () => i18n.t('notValid'),
    test: value => (!!value ? validateHex(value) : true),
  });

export const defaultSectionValidation = Yup.object().shape({
  name: Yup.string()
    .max(MAX_TITLE_LENGTH, i18n.t('nameMustBeCharactersOrLess', { count: MAX_TITLE_LENGTH }))
    .trim()
    .required(i18n.t('sectionNameRequired')),
  settings: Yup.object().shape({
    songsLimit: Yup.string()
      .min(0)
      .max(MAX_LIMIT_DIGITS, i18n.t('mustBeLessThanNumber', { count: 1000 }))
      .nullable(),
    mustPlayLimit: Yup.string()
      .min(0)
      .max(MAX_LIMIT_DIGITS, i18n.t('mustBeLessThanNumber', { count: 1000 }))
      .nullable(),
  }),
});

export const headlineSectionValidation = Yup.object().shape({
  name: Yup.string()
    .max(MAX_TITLE_LENGTH, i18n.t('nameMustBeCharactersOrLess', { count: MAX_TITLE_LENGTH }))
    .trim()
    .required(i18n.t('sectionNameRequired')),
  headlineColor: headlineColorValidateField,
});

export const favoriteSectionsValidation = Yup.object().shape({
  favoriteSectionId: Yup.string()
    .trim()
    .required(i18n.t('required')),
});

export const getCreateSectionValidation = (type: SectionType, createType: SectionCreateKey) => {
  if (createType === SectionCreateKey.newSection) {
    switch (type) {
      case SectionType.simple:
      case SectionType.dontPlay:
        return defaultSectionValidation;
      case SectionType.headline:
        return headlineSectionValidation;
      default:
        return;
    }
  } else {
    return favoriteSectionsValidation;
  }
};

export const CREATE_SECTION_MENU = [
  { name: 'newSection', key: SectionCreateKey.newSection },
  { name: 'addFromFavorites', key: SectionCreateKey.fromFavorites },
];
